import SelfEmployedPrimary from './SelfEmployedPrimary';
import SelfEmployedSecondary from './SelfEmployedSecondary';

import { EmploymentClassType } from '../../PrimaryEmployment/types';

export interface PrimarySelfEmployedProps {
  type: Extract<EmploymentClassType, 'primary'>;
}

export interface SecondarySelfEmployedProps {
  type: Extract<EmploymentClassType, 'secondary'>;
  index: number;
  arrayName: string;
}

export type SelfEmployedProps =
  | PrimarySelfEmployedProps
  | SecondarySelfEmployedProps;

const Employed: React.FunctionComponent<SelfEmployedProps> = function (props) {
  const { type } = props;
  if (type === 'secondary') {
    const { index, arrayName } = props;
    return <SelfEmployedSecondary index={index} arrayName={arrayName} />;
  }
  return <SelfEmployedPrimary />;
};

export default Employed;
